import * as React from 'react';
import './modal-content.css';

export const modalContentHabitat: React.StatelessComponent<{}> = ({ children }) => {
  return <div className="modal-content-habitat">{children}</div>;
};
